import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Custom from "../../../Components/Buttons/Custom";
import { isoToJalali } from "../../../helper/isoToJalali";
import { API_BASE_URL } from "../../../config/api";
import FriendsGrid from "./FriendsGrid";
import FriendsTable from "./FriendsTable";
import usePaginatedReferralList from "./usePaginatedReferralList";

const REFERRAL_CHALLENGES_URL =
  `${API_BASE_URL}payment-payout/referrals/challenges/`;

const formatUsd = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "-";
  }

  return `$${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatPercent = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const percent = Number(value);
  if (!Number.isFinite(percent)) {
    return "-";
  }

  return `${percent.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};

const formatDate = (value) => {
  if (!value || Number.isNaN(new Date(value).getTime())) {
    return "-";
  }

  return isoToJalali(value);
};

export default function Friends() {
  const navigate = useNavigate();
  const [activeFilter] = useState(() => {
    if (window.innerWidth >= 480) {
      return [false, true];
    }
    return [true, false];
  });
  const {
    items: referralData,
    accLoading,
    isLoadingMore,
  } = usePaginatedReferralList({
    endpoint: REFERRAL_CHALLENGES_URL,
    navigate,
  });

  const rows = referralData.map((referral, index) => ({
    id:
      referral.id ??
      referral.uuid ??
      `${referral.created_at ?? "referral"}-${index}`,
    date: formatDate(referral.created_at),
    name: referral.friend_name || "-",
    challenge: referral.challenge_name || "-",
    challengePrice: formatUsd(referral.challenge_price_usd),
    commissionPercent: formatPercent(referral.commission_percent),
    commissionAmount: formatUsd(referral.commission_amount_usd),
    status: referral.status,
  }));

  const listProps = {
    rows,
    accLoading,
    isLoadingMore,
  };

  return (
    <div className="w-full flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          لیست چالش‌های دوستان
        </h3>
        <Custom
          onClick={() => navigate("/rule/invite")}
          text="قوانین دعوت"
          href=""
          className="bg-transparent !px-2.5 !py-1.5 mb:!px-5 mb:!py-2 !rounded-lg mb:!rounded-lg text-zi-text-light dark:text-zi-text-dark border border-zi-border-dark dark:border-zi-border-light/50 hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark hocus:dark:ring-zi-border-light/50 text-xs mb:text-sm"
        />
      </div>

      {activeFilter[0] && <FriendsGrid {...listProps} />}
      {activeFilter[1] && <FriendsTable {...listProps} />}
    </div>
  );
}
